/**
 * This component represents an unadorned list of SelectItem (s).
 */
import React from "react";
import { useMultiSelect } from "../hooks/use-multi-select";
import SelectItem from "./select-item";

var SelectList = _ref => {
  var {
    options,
    onClick: _onClick,
    skipIndex
  } = _ref;
  var {
    disabled,
    value,
    onChange,
    ItemRenderer
  } = useMultiSelect();

  var handleSelectionChanged = (option, checked) => {
    if (disabled) return;
    onChange(checked ? [...value, option] : value.filter(o => o.value !== option.value));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, options.map((o, i) => {
    var tabIndex = i + skipIndex;
    return /*#__PURE__*/React.createElement("li", {
      key: (o == null ? void 0 : o.key) || i
    }, /*#__PURE__*/React.createElement(SelectItem, {
      tabIndex: tabIndex,
      option: o,
      onSelectionChanged: c => handleSelectionChanged(o, c),
      checked: !!value.find(s => s.value === o.value),
      onClick: e => _onClick(e, tabIndex),
      itemRenderer: ItemRenderer,
      disabled: o.disabled || disabled
    }));
  }));
};

export default SelectList;
//# sourceMappingURL=select-list.js.map